import { render, staticRenderFns } from "./RecommendShowModal.vue?vue&type=template&id=59fcf391&"
import script from "./RecommendShowModal.vue?vue&type=script&lang=ts&"
export * from "./RecommendShowModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports